module.exports = __webpack_public_path__ + "media/images/right_show_sidebar/cal-9f8e831639b78f1e11c5cccf926be5d4.svg";